module.exports = __webpack_public_path__ + "static/sixth_user_image1-bd850c9cd13c59ab43c21a03a737314e.jpg";